import { useJourneyReviewContext } from 'modules/workflows/context/JourneyReviewContext';
import { StyledBody, StyledBodyHeader } from './JourneyReview.styles';
import { JourneyPerformanceList } from './components/JourneyReviewList';
import {
  ErrorLoadingPerformanceIssues,
  LoadingItems,
  NoPerformanceIssuesFound,
} from './components/JourneyReviewState';

export const JOURNEY_PERFORMANCE_LIST_TEST_ID = 'journey-performance';
export const JourneyPerformance = () => {
  const { optimizations, isOptimizationsLoading, hasOptimizationError, getOptimizations } =
    useJourneyReviewContext();
  if (hasOptimizationError) return <ErrorLoadingPerformanceIssues retry={getOptimizations} />;
  if (!optimizations.length && !isOptimizationsLoading) return <NoPerformanceIssuesFound />;
  return (
    <StyledBody data-test={JOURNEY_PERFORMANCE_LIST_TEST_ID}>
      <StyledBodyHeader>
        Suggestions for improving your journey&apos;s efficiency and processing speeds. (Click each
        item to view the affected tiles.)
      </StyledBodyHeader>
      {isOptimizationsLoading ? (
        <LoadingItems />
      ) : (
        <JourneyPerformanceList optimizations={optimizations} />
      )}
    </StyledBody>
  );
};
